// src/firebase.js (क्विज़ प्लेयर के लिए)

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// (हमें यहाँ Auth की ज़रूरत नहीं है, क्योंकि प्लेयर को लॉगिन नहीं करना है)

// 1. चाबियों को .env फ़ाइल से पढ़ें
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// 2. जाँच करें कि वे लोड हुई हैं
if (!firebaseConfig.apiKey) {
  throw new Error("Firebase config (API Key) is missing. Check your .env file.");
}

// फायरबेस ऐप को शुरू करें
const app = initializeApp(firebaseConfig);

// सेवाओं (services) को export करें
export const db = getFirestore(app); // <-- हमें सिर्फ डेटाबेस (db) चाहिए